import axios from 'axios'

// Secure httpOnly cookie-based authentication
// No tokens in localStorage - cookies handled automatically by browser
export const api = axios.create({ 
  baseURL: '/api',
  withCredentials: true  // Sends httpOnly cookies with every request
})

// Check if user is authenticated by testing a protected endpoint
export async function isAuthed() {
  try {
    await api.get('/auth/me')
    return true
  } catch {
    return false
  }
}

// Logout - calls backend to clear httpOnly cookie
export async function logout() {
  try {
    await api.post('/auth/logout')
  } catch {
    // Ignore errors, redirect anyway
  }
}

// No automatic redirects - admin routes stay hidden from regular users
api.interceptors.response.use(r => r, err => {
  return Promise.reject(err)
})
